// @flow
import React, { useState, Fragment } from "react";
import Button from "../Button";
import QuotablesGroup from "./QuotablesGroup";
import { fetchJson } from "../../lib/Fetching";
import { fetchSampleQuotables } from "../../lib/SamplesData";
import WithdrawSampleQuotables from "./WithdrawSampleQuotables";

type Props = {
  sampleId: number,
  onWithdrawal: Function,
  withdrawing: [],
  displayOnly: ?boolean
};

export default class ExistingSampleQuotables extends React.Component<Props> {
  state = {
    sampleQuotables: [],
    selectedIds: [],
    loaded: false
  };

  static defaultProps = {
    displayOnly: false
  };

  existingQuotables = () => {
    const { withdrawing } = this.props;
    const { sampleQuotables } = this.state;

    return sampleQuotables
      .filter(
        sampleQuotable =>
          !withdrawing.some(o => o.sample_quotable_ids.includes(sampleQuotable.id))
      )
      .map(sq => sq.quotable);
  };

  fetchData = () => {
    const { sampleId } = this.props;
    return fetchSampleQuotables(sampleId).then(({ sample_quotables }) => {
      this.setState({
        sampleQuotables: sample_quotables,
        loaded: true
      });
    });
  };

  startWithdrawing = () => {
    const { withdrawing, onWithdrawal } = this.props;
    const { sampleQuotables, selectedIds } = this.state;
    const toWithdraw = sampleQuotables.filter(sq => selectedIds.includes(sq.id));
    withdrawing.push({
      reason: "",
      sample_quotable_ids: toWithdraw.map(sq => sq.id)
    });
    this.setState({ selectedIds: [] });
    onWithdrawal(withdrawing);
    console.log("IN CLASS", withdrawing);
  };

  componentDidMount() {
    this.fetchData();
  }

  handleUpdateWithdrawal = (originalWithdraw, updatedWithdraw) => {
    const { onWithdrawal, withdrawing } = this.props;
    withdrawing.splice(withdrawing.indexOf(originalWithdraw), 1, updatedWithdraw);
    this.setState({ withdrawing });
    onWithdrawal(withdrawing);
  };

  handleCancelWithdrawal = withdrawal => {
    const { onWithdrawal, withdrawing } = this.props;
    withdrawing.splice(withdrawing.indexOf(withdrawal), 1);
    this.setState({ withdrawing });
    onWithdrawal(withdrawing);
  };

  render() {
    const { withdrawing, displayOnly } = this.props;
    const { sampleQuotables, selectedIds, loaded } = this.state;

    return (
      <div className="sample_testing">
        <div
          className="basic-panel with-padding with-rounded-corners with-shadow"
          style={{ marginBottom: 10 }}
        >
          <h4>Existing Testing</h4>
          {!loaded && (
            <p>
              <i class="fa fa-spinner fa-spin"></i>&nbsp; Loading...
            </p>
          )}
          {withdrawing.map(withdraw => (
            <WithdrawSampleQuotables
              allSampleQuotables={sampleQuotables}
              withdraw={withdraw}
              onCancelWithdrawal={() => this.handleCancelWithdrawal(withdraw)}
              onChange={updatedWithdraw =>
                this.handleUpdateWithdrawal(withdraw, updatedWithdraw)
              }
            />
          ))}
          {loaded && (
            <Fragment>
              {!displayOnly && (
                <div className="pull-left">
                  <Button
                    title={"Withdraw Selected Tests"}
                    disabled={selectedIds.length === 0 || withdrawing.length > 0}
                    deleting
                    small
                    onClick={this.startWithdrawing}
                  />
                </div>
              )}
              <QuotablesGroup
                selectSampleQuotables
                quotables={this.existingQuotables()}
                selectedIds={selectedIds}
                onChangeIds={ids => this.setState({ selectedIds: ids })}
              />
              <p className="text-right small" style={{ marginTop: 10 }}>
                Individual item prices shown are the standard prices from the quote and do not
                include turnaround premiums that may apply to this sample.
              </p>
            </Fragment>
          )}
        </div>
      </div>
    );
  }
}
